import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Bars3Icon,
  XMarkIcon,
  UserIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";

import { useUserContext } from "../../context/UserContext";
import { ServiceGroups } from "../../config/serviceConfig";
import { authService } from "@/auth/services/authService";
import { useAppBasePath } from "@/router/useAppBasePath";

const Header: React.FC<{ onSelectServiceType?: (id: string | null) => void }> = ({
  onSelectServiceType,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, basicData, setToken, setUser, logout } = useUserContext();
  const userRole = user?.role_name === "Admin" ? "Admin" : "User";
  const userLandingPage = userRole === "Admin" ? "/admin" : "/home";

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [authDropdownOpen, setAuthDropdownOpen] = useState(false);

  const isSignedIn = !!basicData?.email;

  const basePath = useAppBasePath();  
  console.log(basePath);

  useEffect(() => {
    setAuthDropdownOpen(false);
  }, [location.pathname]);

  const handleNavClick = (group: ServiceGroups | null) => {
    navigate("/", { state: { group } });
    onSelectServiceType?.(group);
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

const handleAuthNavigateNew = (
  entryTab: "sso" | "signin" | "register" | "test"
) => {
  const AUTH_URL =
    import.meta.env.VITE_AUTH_URL || "http://localhost:8000";

  const returnUrl = encodeURIComponent(
    `${window.location.origin}/authorize/callback`
  );

  switch (entryTab) {
    case "sso":
      window.location.href =
        `${AUTH_URL}/oauth/sso?return_url=${returnUrl}`;
      break;

    case "test":
      window.location.href =
        `${AUTH_URL}/oauth/test/login?return_url=${returnUrl}`;
      break;

    case "signin":
      window.location.href =
        `${AUTH_URL}/auth-ui/login?return_url=${returnUrl}`;
      break;

    case "register":
      window.location.href =
        `${AUTH_URL}/auth-ui/signup?return_url=${returnUrl}`;
      break;

    default:
      window.location.href =
        `${AUTH_URL}/auth-ui/login?return_url=${returnUrl}`;
  }
};

  return (
    <>
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="w-full px-4 sm:px-6 py-3 flex justify-between items-center">
          {/* Logo */}
          <button
            onClick={() => {
              navigate("/");
              if (!isSignedIn) {
                navigate("/");
              } else {
                navigate(`${userLandingPage}`);

              }
            }}
            className="focus:outline-none"
          >
            <img
              src="/assets/images/logos/7HillsLabLogo.png"
              alt="7hillsLAB"
              className="h-8 w-32 sm:h-10 sm:w-40"
            />
          </button>

          {/* Right Section */}
          <div className="flex items-center gap-4 relative">
            {/* Desktop Navigation */}
            {!isSignedIn && (

            <nav className="hidden sm:flex items-center gap-6 text-sm text-black">
                <>
                  <button
                    onClick={() => handleNavClick(ServiceGroups.CAREER)}
                    className="hover:text-blue-600 transition-colors"
                  >
                    Career Development Programs
                  </button>
                  <button
                    onClick={() => handleNavClick(ServiceGroups.ACADEMIC)}
                    className="hover:text-blue-600 transition-colors"
                  >
                    Academic Programs
                  </button>
                  <button
                    onClick={() => handleNavClick(ServiceGroups.CORPORATE)}
                    className="hover:text-blue-600 transition-colors"
                  >
                    Corporate Services
                  </button>
                </>
            </nav>
            )}

            {/* Auth Section */}
            {isSignedIn ? (
              <div className="relative">
                <button
                  onClick={() => setAuthDropdownOpen((prev) => !prev)}
                  className="flex items-center gap-1 px-3 py-1.5 rounded-md border border-gray-300 text-sm text-black bg-green-100 hover:bg-green-200 transition-colors"
                >
                  <UserIcon className="h-5 w-5" />
                  Signed-In
                  <ChevronDownIcon className="h-4 w-4" />
                </button>

                {authDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-44 rounded-md border border-gray-200 bg-white shadow-xl z-50">
                    {/* <button
                      className="w-full px-3 py-2 text-left text-sm text-black hover:bg-blue-50 transition-colors"
                      onClick={() => navigate("/home")}
                    >
                      Services
                    </button>
                    <button
                      className="w-full px-3 py-2 text-left text-sm text-black hover:bg-blue-50 transition-colors"
                      onClick={() => navigate("/dashboard")}
                    >
                      Dashboard
                    </button> */}

                    {userRole !== "Admin" && (
                      <>
                        {/* <button
                          className="w-full px-3 py-2 text-left text-sm text-black hover:bg-blue-50 transition-colors"
                          onClick={() => navigate("/dashboard")}
                        >
                          Dashboard
                        </button> 
                        <button
                          className="w-full px-3 py-2 text-left text-sm text-black hover:bg-blue-50 transition-colors"
                          onClick={() => navigate("/payments")}
                        >
                          My Payments
                        </button> */}
                        <button
                          className="w-full px-3 py-2 text-left text-sm text-black hover:bg-blue-50 transition-colors"
                          onClick={() => navigate(`${basePath}/profile`)}
                        >
                          My Profile
                        </button>
                      </>
                    )}

                    <button
                      className="w-full px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50 transition-colors"
                      onClick={handleLogout}
                    >
                      Sign Out
                    </button>
                  </div>
                )}
                {/* <div>
                  Welcome {user?.name}
                </div> */}
              </div>
              
            ) : (
              <>
 
              <div className="relative">
                <button
                  onClick={() => setAuthDropdownOpen((prev) => !prev)}
                  className="flex items-center gap-1 px-3 py-1.5 rounded-md border border-gray-300 text-sm text-black hover:bg-gray-50 transition-colors"
                >
                  <UserIcon className="h-5 w-5" />
                  Sign In
                  <ChevronDownIcon className="h-4 w-4" />
                </button>

                {authDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-44 rounded-md border border-gray-200 bg-white shadow-xl z-50">
                    {[
                      { label: "Guest", tab: "sso" },
                      { label: "Registered", tab: "signin" },
                      { label: "New User", tab: "register" },
                      { label: "Test Login", tab: "test" },
                    ].map((item) => (
                      <button
                        key={item.label}
                        className="w-full px-3 py-2 text-left text-sm text-black hover:bg-blue-50 transition-colors"
                        onClick={() => handleAuthNavigateNew(item.tab as any)}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              </>
            )}

            {/* Mobile Hamburger */}
            <button
              className="sm:hidden"
              onClick={() => setMobileMenuOpen((prev) => !prev)}
            >
              {mobileMenuOpen ? (
                <XMarkIcon className="h-6 w-6 text-black" />
              ) : (
                <Bars3Icon className="h-6 w-6 text-black" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="sm:hidden bg-white shadow-md border-t px-4 py-3 space-y-2 text-sm text-black">
            {!isSignedIn ? (
              <>
                <button onClick={() => handleNavClick(ServiceGroups.CAREER)} className="block w-full text-left hover:text-blue-600">Career Devewlopment Programs</button>
                <button onClick={() => handleNavClick(ServiceGroups.ACADEMIC)} className="block w-full text-left hover:text-blue-600">Academic Programs</button>
                <button onClick={() => handleNavClick(ServiceGroups.CORPORATE)} className="block w-full text-left hover:text-blue-600">Corporate Services</button>
              </>
            ) : (
              <>
                <button onClick={() => navigate("/dashboard")} className="block w-full text-left hover:text-blue-600">My Dashboard</button>
                <button onClick={() => navigate("/payment")} className="block w-full text-left hover:text-blue-600">My Payments</button>
              </>
            )}
          </div>
        )}
      </header>
    </>
  );
};

export default Header;